import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { TenantSidebarFooter } from '~components/layout/sidebar/components/tenant-sidebar-footer';
import { tenantSidebarLinks } from '~components/layout/sidebar/tenant-sidebar-routes';
import { Logo } from '~components/ui/logo/logo';

import { useMobileMenu } from '~hooks/use-mobile-menu';

import { ROUTES } from '~app/router/routes';

import { SidebarMenu } from './menu/sidebar-menu';
import { SidebarWrapper } from './sidebar.styles';

export const TenantSidebar = () => {
  const { isMenuOpen, closeMenu } = useMobileMenu();

  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      closeMenu();
      prevPathname.current = pathname;
    }
  }, [pathname, closeMenu]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <>
      <SidebarWrapper isMenuOpen={isMenuOpen}>
        <Box
          sx={{
            width: '100%',
            display: { xs: 'none', md: 'flex' },
            justifyContent: 'center',
            mb: 5,
          }}
        >
          <Logo to={ROUTES.TENANT_SCOPE} />
        </Box>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            pr: 0.5,
            mb: 0.5,
          }}
        >
          <SidebarMenu links={tenantSidebarLinks} />
        </Box>

        <Box sx={{ flexShrink: 0 }}>
          <TenantSidebarFooter />
        </Box>
      </SidebarWrapper>

      <Box
        role={'button'}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 9,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          opacity: isMenuOpen ? 1 : 0,
          visibility: isMenuOpen ? 'visible' : 'hidden',
          pointerEvents: isMenuOpen ? 'auto' : 'none',
          transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out',
        }}
        onClick={closeMenu}
      />
    </>
  );
};
